/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_HeadingInputs */

const en_try_magic_heading = /** @type {(inputs: Try_Magic_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try the magic for yourself`)
};

const es_try_magic_heading = /** @type {(inputs: Try_Magic_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba la magia por ti mismo`)
};

/**
* | output |
* | --- |
* | "Try the magic for yourself" |
*
* @param {Try_Magic_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_heading = /** @type {((inputs?: Try_Magic_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_heading(inputs)
	return en_try_magic_heading(inputs)
});